'use strict';

/* global $ */

const { toastFunction } = require('sharkninja/common');

/**
 * Returns a generic error toast using toastFunction
 * @param {string} message - The body message to show
 * @param {string} [title='Error'] - Optional title
 * @returns {jQuery} Toast element
 */
function toastErrorMessage(message, title = 'Error') {
    return toastFunction({
        type: 'error',
        title: title,
        message: message
    });
}

/**
 * Returns a generic success toast using toastFunction
 * @param {string} message - The body message to show
 * @param {string} [title='Success'] - Optional title
 * @returns {jQuery} Toast element
 */
function toastSuccessMessage(message, title = 'Success') {
    return toastFunction({
        type: 'success',
        title: title,
        message: message
    });
}

/**
 * Appends the generated toast HTML to DOM and removes it after timeout
 * @param {string} toastHtml - HTML string returned by toastSuccessMessage or toastErrorMessage
 */
function appendToastMessage(toastHtml) {
    $('.generic-toast-message-wrapper').empty();
    $('.generic-toast-message-wrapper').append(toastHtml);
    setTimeout(() => toastHtml.fadeOut(3000, () => toastHtml.remove()), 5000);
}

module.exports = {
    toastErrorMessage,
    toastSuccessMessage,
    appendToastMessage
};
